import { Routes } from '@angular/router'
import {
  ABOUT_PATH,
  HOME_PATH,
  PROFILE_PATH,
  SIGN_TYPE_PATH, SINGLE_SIGN_PATH
} from './general/shared'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: HOME_PATH,
    loadComponent: () => import('./components/home/home').then(m => m.Home)
  },
  {
    path: `${SIGN_TYPE_PATH}/:consentId`,
    loadComponent: () => import('./components/sign-type/sign-type').then(m => m.SignType)
  },
  {
    path: `${SINGLE_SIGN_PATH}/:consentId`,
    loadComponent: () => import('./components/singel-sign/singel-sign').then(m => m.SingelSign)
  },
  {
    path: ABOUT_PATH,
    loadComponent: () => import('./components/about/about').then(m => m.About)
  },
  {
    path: PROFILE_PATH,
    loadComponent: () => import('./components/profile/profile').then(m => m.Profile)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
] satisfies Routes
